import {Component} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ManageAdsBannerPhotoComponent} from "../ads-banner-photo/manage-ads-banner-photo.component";
import {Router} from "@angular/router";
import {PhotoService} from "../../../photo/services/photo.service";
import {environment} from "../../../../../environments/environment";
import {ToastrService} from "ngx-toastr";
import {LocationService} from "../../../../shared/services/location.service";
import {AdvertisingService} from "../../../../shared/services/advertising.service";
import AppShareHelper from "../../../../shared/utils/helper";
import { TranslateService } from "../../../../shared/services/translate.service";
declare var jQuery: any;

@Component({
    selector: 'app-view-explore-photo',
    templateUrl: './view-explore-photo.component.html',
    styleUrls: ['./view-explore-photo.component.css'],
})
export class ViewExplorePhotoComponent {
    constructor(public activeModal: NgbActiveModal,
                protected _modalService: NgbModal,
                protected toastr: ToastrService,
                protected locationService: LocationService,
                protected advertisingService: AdvertisingService,
                private router: Router,
                private photoService: PhotoService,
                private translateService: TranslateService) {
    }

    locationDetail;
    locationPhotos = [];
    photoDetail: any = {};
    customerInfo = {
        fullName: null,
        status : ''
    };
    isAdmin = false;
    groupId = null;
    advertising: any = {
        navigateUrl : null,
        bannerThumbUrl : null,
    };
    locationDetailArr = [];
    currentViewIndex = 0;


    ngOnInit() {
        if (this.locationDetailArr.length) {
            this.getInfoFromMarker()
        } else {
            this.getPhotoCustomerInfo();
        }
    }
    
    switchPhoto(option) {
        if (option === 'next') {
            if (this.currentViewIndex == (this.locationDetailArr.length - 1)) {
                this.currentViewIndex = 0
            } else {
                this.currentViewIndex++;
            }
        } else {
            if (this.currentViewIndex == 0) {
                this.currentViewIndex = this.locationDetailArr.length - 1
            } else {
                this.currentViewIndex--;
            }
        }

        this.getInfoFromMarker()
    };

    getAdvertisingInfo(photoId) {
        this.advertisingService.getPhotoAdvertising(photoId).toPromise().then((res: any) => {
            if (res.Data && res.Data.length) {
                this.advertising = res.Data[0]
            } else {
                this.advertising = {};
            }
        })
    }
    
    translate(locationDetail) {
        if (locationDetail.originalAddress) {
            locationDetail['address'] = locationDetail.originalAddress;
            locationDetail['description'] = locationDetail.originalDescription;
            delete locationDetail.originalAddress;
            delete locationDetail.originalDescription;
        } else {
            this.translateService.translate([locationDetail['address'], locationDetail['description']], navigator.language).toPromise().then((res: any) => {
                locationDetail.originalAddress = locationDetail.address;
                locationDetail.originalDescription = locationDetail.description;
                locationDetail.address = res.data && res.data.translations ? res.data.translations[0].translatedText : locationDetail.address;
                locationDetail.description = res.data && res.data.translations ? res.data.translations[1].translatedText : locationDetail.description;
            })
        }
    }
    
    public translationButtonText(location) {
        return AppShareHelper.translationButtonText(location, 'originalAddress');
    }
    
    getLocationGallery() {
        this.photoService.getPhotosByLocationId(this.locationDetail.id).toPromise().then((res: any) => {
            if (res.Data && res.Data.length) {
                this.locationPhotos = res.Data;
                jQuery('#carousel-example').on('slide.bs.carousel', function (e) {
                    let jQuerye = jQuery(e.relatedTarget);
                    let idx = jQuerye.index();
                    let itemsPerSlide = 4;
                    let totalItems = jQuery('.carousel-item').length;
        
                    if (idx >= totalItems-(itemsPerSlide-1)) {
                        var it = itemsPerSlide - (totalItems - idx);
                        for (let i=0; i<it; i++) {
                            // append slides to end
                            if (e.direction=="left") {
                                jQuery('.carousel-item').eq(i).appendTo('.carousel-inner');
                            }
                            else {
                                jQuery('.carousel-item').eq(0).appendTo('.carousel-inner');
                            }
                        }
                    }
                });
            }
        })
    }
    

    getInfoFromMarker() {
        this.locationDetail = this.locationDetailArr[this.currentViewIndex].options.photoData;
        this.getPhotoCustomerInfo();
    }

    editAds() {
        const modalRef = this._modalService.open(ManageAdsBannerPhotoComponent, {centered: true});
        modalRef.componentInstance.photoModel = {
            ...this.photoDetail,
            advertisings : [
                this.advertising
            ]
        };
        modalRef.componentInstance.advertisingUrl = this.advertising.bannerThumbUrl;
        modalRef.componentInstance.navigateUrl = this.advertising.navigateUrl;
        modalRef.componentInstance.uploadSuccess.subscribe((res) => {
            this.getAdvertisingInfo(this.photoDetail.id);
            this.toastr.success('Update ads successfully');
        })
    }

    convertLinkImage(link) {
        return environment.production ? link.replace('http:', 'https:') : link;
    }

    preventDefault(event, prevent) {
        if (prevent) {
            event.preventDefault();
        } else {
            return;
        }
    }

    openLocationDetail() {
        this._modalService.dismissAll();
        this.router.navigate(['/photo/' + this.photoDetail.id]);
    }
    
    openPhoto(photoId) {
        this._modalService.dismissAll();
        window.open(environment['site'] + environment['prefixDomain'] + 'photo/' + photoId, '_blank')
    }
    
    getPhotoCustomerInfo() {
        this.locationService.getLocationDetail(this.locationDetail.id).toPromise().then((res: any) => {
            this.locationDetail = res.Data;
            if (this.locationDetail.photo.length) {
                for (const photo of this.locationDetail.photo) {
                    if (photo.isPrimaryLocation) {
                        this.photoDetail = photo;
                        this.customerInfo = this.locationDetail.customer;
                        this.getAdvertisingInfo(this.photoDetail.id);
                        if (this.isAdmin || this.groupId) {
                            this.getLocationGallery();
                        }
                        break;
                    }
                }
            }
        })
    }
}
